import { FC } from "react";
import { Link } from "react-router-dom";
import { ChalkPageShell } from "../../shared/component/ChalkPageShell/ChalkPageShell";
import { Seo } from "../../shared/component/Seo/Seo";
import { ROUTES } from "../../shared/model/routes";
import { SITE_SHARE_IMAGE } from "../../shared/model/siteAssets";
import "./style.css";

const NotFoundPage: FC = () => {
  const eventsPath = ROUTES.EVENTS.startsWith("/") ? ROUTES.EVENTS : `/${ROUTES.EVENTS}`;

  return (
    <ChalkPageShell mainClassName="chalk-page__main--missing" showHomeBack>
      <Seo
        title="Страница не найдена — Дофамин"
        description="Такой страницы на сайте театра «Дофамин» нет."
        noindex
        imageUrl={SITE_SHARE_IMAGE}
      />
      <h1 className="chalk-page__title">404</h1>
      <p className="chalk-missing__text">Такой страницы на доске нет.</p>
      <div className="chalk-missing__links">
        <Link to={ROUTES.HOME} className="chalk-missing__link">
          На главную
        </Link>
        <Link to={eventsPath} className="chalk-missing__link">
          Афиша
        </Link>
      </div>
    </ChalkPageShell>
  );
};

export const Component = NotFoundPage;
